/**
 * 🎨 GRID & CELL CONTROLS 2025
 * 
 * Kombinierte Controls für Grids und Cells
 * - Edit, Delete, Duplicate in EINEM Container
 * - Klein und dezent oben rechts
 * - Branding Farben
 */

import React, { useState } from 'react';
import DeleteElementModal from './DeleteElementModal';
import './GridCellControls.css';

function GridCellControls({ 
    onEdit,
    onDelete, 
    onDuplicate,
    elementType = 'cell', // 'cell' oder 'grid'
    canDelete = true, // z.B. false wenn letzte Cell
    showEdit = true,
    showDuplicate = true,
    showDelete = true,
    forceHidden = false // ✅ NEU: Force hidden wenn hierarchisch versteckt
}) {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    
    // Bestimme Element-Namen für Modal
    const elementName = elementType === 'grid' ? 'Grid' : 'Cell';
    
    return (
        <>
            <div className={`grid-cell-controls-container ${forceHidden ? 'force-hidden' : ''}`}>
                {/* 🎨 Edit Button */}
                {showEdit && (
                    <button
                        className="grid-cell-control-btn grid-cell-control-edit"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit();
                        }}
                        title={`Edit ${elementName}`}
                    >
                        <i className="fas fa-cog"></i>
                    </button>
                )}
                
                {/* 📋 Duplicate Button */}
                {showDuplicate && onDuplicate && (
                    <button
                        className="grid-cell-control-btn grid-cell-control-duplicate"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDuplicate();
                        }}
                        title={`Duplicate ${elementName}`}
                    >
                        <i className="fas fa-copy"></i>
                    </button>
                )}
                
                {/* 🗑️ Delete Button */}
                {showDelete && (
                    <button
                        className={`grid-cell-control-btn grid-cell-control-delete ${!canDelete ? 'disabled' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (canDelete) {
                                setShowDeleteModal(true);
                            }
                        }}
                        title={canDelete ? `Delete ${elementName}` : `Cannot delete last ${elementName.toLowerCase()}`}
                        disabled={!canDelete}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </button>
                )}
            </div>
            
            {/* 🗑️ Delete Modal */}
            <DeleteElementModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={() => {
                    onDelete();
                    setShowDeleteModal(false);
                }}
                elementType={elementType}
            />
        </>
    );
}

export default GridCellControls;

